import {FontAwesomeIcon, FontAwesomeIconProps} from "@fortawesome/react-fontawesome";
import {Box, Sheet, SheetProps, Stack} from "@mui/joy";
import {ReactNode} from "react";

import {TimelineTimeCoordinate} from "../timeline/timelineTimeCoordinate.tsx";
import {formatTileTimelineCoordinate} from "../timeline/formatTileTimelineCoordinate.ts";

// export const UNKNOWN_WHEN = "??";

export interface SceneTileContentProps extends SheetProps {
    when: TimelineTimeCoordinate;
    what: ReactNode;
    where?: ReactNode,
    icon?: FontAwesomeIconProps,
}

export function SceneIcon({icon}: { icon: FontAwesomeIconProps }) {
    return <Box sx={{py: 0.6}}><FontAwesomeIcon size="2x" {...icon}/></Box>
}

export function SceneTileContent({when, what, where, icon, color, variant, children}: SceneTileContentProps) {
    const fmtwhen = formatTileTimelineCoordinate(when)

    return <Stack direction="column" sx={{alignItems: "center"}}>
        <Sheet color={color} variant={variant} sx={{flex: 0, px: 0.6, py: 0.4}}>
            {fmtwhen}
        </Sheet>
        <Box sx={{flex: 1}}>{what}</Box>
        {where}
        {icon ? <SceneIcon icon={icon}/> : null}
        {children}
    </Stack>
}

// if you leave color out of the dispatch tile props, it will be
// promoted from the content.

// export interface DispatchTileProps extends PropsWithChildren<JoyableProps> {
//     marquee?: ReactNode;
//     isStarred?: boolean;
// }

// export function DispatchTile(
//     {children, marquee, isStarred, ...tileProps}: DispatchTileProps) {
//     const {variant: oyaVariant, color, invertedColors, ...tileRest} = tileProps;
//     const theme = useTheme();
//     const childVariant = oyaVariant === "outlined" ? "plain" : oyaVariant;
//     const colors = figureColors({
//         theme, color: color, variant: oyaVariant, invertedColors
//     });
//
//     return <StyledTile ownerState={{...tileProps, variant: oyaVariant, color}}
//                        variant={oyaVariant} color={color}
//                        {...tileRest}>
//         <CardContent>
//             {isStarred
//                 ? <IconButton variant="solid" color="warning" size="sm"
//                               sx={{position: "absolute", top: "0.875rem", right: "0.5rem"}}>
//                     <FontAwesomeIcon icon={faStarSharp}/>
//                 </IconButton>
//                 : null}
//             <Stack direction="column" spacing={0.2} sx={{alignItems: "center", bgcolor: bgColor}}>
//                 <Box sx={{
//                     pb: 1.2,
//                     width: "100%",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     fontSize: "xl",
//                     variant: childVariant,
//                 }}>
//                     {marquee}
//                 </Box>
//
//                 {children}
//
//                 {/*TODO: actions*/}
//             </Stack>
//         </CardContent>
//     </StyledTile>
// }

